import { UserInfo } from '@weave/schema-gen-ts/dist/schemas/announcements/v1/announcements.pb';

export const getName = (user: UserInfo) => {
  if (user.firstName && user.lastName) {
    return `${user.firstName} ${user.lastName}`;
  }
  return user.username || 'Unknown User';
};
